<div [ngClass]="isCard ? 'c-card' : ''">
    <div [ngClass]="isCard ? 'c-card__header' : ''">
        <div [ngClass]="isCard ? 'c-card__ribbon' : ''">
            <div [ngClass]="isCard ? 'c-card__item c-card__item--left mb-2' : ''">
                @if (showTitle) {
                    @if (!isRequired) {
                        <h3>{{ title }}</h3>
                    } @else {
                        <h3>
                            {{ title }}
                            @if (editMode) {
                                <span class="required-asterisk">*</span>
                            }
                        </h3>
                    }
                }
            </div>
            <div [ngClass]="isCard ? 'header-buttons' : 'noCard-header-buttons'">
                @if (showEditSaveButton) {
                    <div>
                        @if (editMode) {
                            <div [ngClass]="isCard ? 'c-card__item c-card__item--right' : ''">
                                <mds-button
                                    [id]="'saveBtn'"
                                    (clickEvent)="updateEditStatus()"
                                    label="Save"
                                    color="primary"
                                    [variant]="'tonal'"
                                ></mds-button>
                            </div>
                        }
                        @if (!editMode && patient?.statusId !== 2) {
                            <div [ngClass]="isCard ? 'c-card__item c-card__item--right' : ''">
                                <mds-button
                                    [id]="'editBtn'"
                                    (clickEvent)="updateEditStatus()"
                                    label="Edit"
                                    color="primary"
                                    [variant]="'tonal'"
                                ></mds-button>
                            </div>
                        }
                    </div>
                }
            </div>
        </div>
    </div>
    <div class="c-card__content">
        <form #ngForm="ngForm" class="c-form" [formGroup]="cardFormGroup" appScrollToInvalidControlOnSubmit>
            <div class="o-grid">
                @if (type === 'site-info') {
                    <div class="o-grid__row">
                        <div class="o-grid__item">
                            <medpace-site-info
                                (inputChangeEvent)="passContentAlong($event)"
                                [isEditing]="editMode"
                                [parentFormGroup]="cardFormGroup"
                            ></medpace-site-info>
                        </div>
                    </div>
                }
                @if (type === 'study-info') {
                    <div class="o-grid__row">
                        <div class="o-grid__item">
                            <medpace-study-info-card
                                (inputChangeEvent)="passContentAlong($event)"
                                [content]="inputObj"
                                [isEditing]="editMode"
                                [parentFormGroup]="cardFormGroup"
                                [isClinTrakComparison]="isClinTrakComparison"
                            ></medpace-study-info-card>
                        </div>
                    </div>
                }
                @if (type === 'study-detail') {
                    <div class="o-grid__row">
                        <div class="o-grid__item">
                            <medpace-study-details-card
                                (inputChangeEvent)="passContentAlong($event)"
                                [isEditing]="editMode"
                                [parentFormGroup]="cardFormGroup"
                                [isClinTrakComparison]="isClinTrakComparison"
                            ></medpace-study-details-card>
                        </div>
                    </div>
                }
                @if (type === 'site-address') {
                    <div class="o-grid__row">
                        <div class="o-grid__item">
                            <medpace-site-address
                                [isModal]="isModal"
                                (inputChangeEvent)="passContentAlong($event)"
                                [isEditing]="editMode"
                                [parentFormGroup]="cardFormGroup"
                            ></medpace-site-address>
                        </div>
                    </div>
                }
                @if (type === 'site-shipping-address') {
                    <div class="o-grid__row">
                        <div class="o-grid__item">
                            <medpace-site-shipping-address
                                [isModal]="isModal"
                                (inputChangeEvent)="passContentAlong($event)"
                                [isEditing]="editMode"
                                [parentFormGroup]="cardFormGroup"
                            ></medpace-site-shipping-address>
                        </div>
                    </div>
                }
                @if (type === 'site-crc-invite') {
                    <div class="o-grid__row">
                        <div class="o-grid__item">
                            <medpace-crc-invite-card
                                [isEditing]="editMode"
                                [parentFormGroup]="cardFormGroup"
                                (inputChangeEvent)="passContentAlong($event)"
                            ></medpace-crc-invite-card>
                        </div>
                    </div>
                }
                @if (type === 'consent-card') {
                    <div class="o-grid__row">
                        <div class="o-grid__item">
                            <medpace-consent
                                (consentChangeEvent)="passContentAlong($event)"
                                [isEditing]="editMode"
                                [parentFormGroup]="cardFormGroup"
                            ></medpace-consent>
                        </div>
                    </div>
                }
                @if (type === 'payment-card') {
                    <div class="o-grid__row">
                        <div class="o-grid__item">
                            <medpace-payment-card
                                (inputChangeEvent)="passContentAlong($event)"
                                [isAdmin]="elevatedAccess"
                                [isEditing]="editMode"
                                [isPatientProfile]="isPatientProfile"
                                [parentFormGroup]="cardFormGroup"
                            ></medpace-payment-card>
                        </div>
                    </div>
                }
                @if (type === 'travel-card') {
                    <div class="o-grid__row">
                        <div class="o-grid__item">
                            <medpace-travel-card
                                (inputChangeEvent)="passContentAlong($event)"
                                [isEditing]="editMode"
                                [isUpdate]="isUpdate"
                                [parentFormGroup]="cardFormGroup"
                            ></medpace-travel-card>
                        </div>
                    </div>
                }
                @if (type === 'accessiblity-card') {
                    <div class="o-grid__row">
                        <div class="o-grid__item">
                            <medpace-accessibility-card
                                [parentFormGroup]="cardFormGroup"
                                (inputChangeEvent)="passContentAlong($event)"
                                [isEditing]="editMode"
                            ></medpace-accessibility-card>
                        </div>
                    </div>
                }
                @if (type === 'request-type') {
                    <div class="o-grid__row">
                        <div class="o-grid__item">
                            <div>
                                <medpace-request-type-select-card
                                    (requestTypeChangeEvent)="passContentAlong($event)"
                                    [isEditing]="editMode"
                                    [isUpdate]="isUpdate"
                                    [parentFormGroup]="cardFormGroup"
                                ></medpace-request-type-select-card>
                            </div>
                        </div>
                    </div>
                }
                @if (type === 'additional-info') {
                    <div class="o-grid__row">
                        <div class="o-grid__item">
                            <medpace-additional-travel-info-card
                                (additionalInfoChange)="passContentAlong($event)"
                                [isEditing]="editMode"
                                [request]="inputObj"
                            ></medpace-additional-travel-info-card>
                        </div>
                    </div>
                }
            </div>
        </form>
    </div>
    <ng-template #spinner>
        <medpace-loading-card></medpace-loading-card>
    </ng-template>
</div>
